import axiosInstance from "../../../middlewares/axiosInstance";
import { AxiosResponse } from "axios";
import { IESDoc } from "../../../app.interface";

interface Filter {
  id: string;
  title: string;
  field: string;
  operator: string;
  value: any;
}

interface ListParams {
  searchQuery?: string;
  filters?: Filter[];
  startDate?: number;
  endDate?: number;
  dateField?: string;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  pageIndex?: number;
  pageSize?: number;
  status?: "active" | "inactive";
}

interface ListResponse {
  data: IESDoc[];
  metadata: {
    total: {
      value: number;
    };
    took: number;
    timed_out: boolean;
    max_score: number | null;
  };
}

class StaffService {
  async listStaffMembers(params: ListParams): Promise<ListResponse> {
    const response = await axiosInstance.post("/business-admin/staff/list", {
      ...params,
    });
    return response.data.data;
  }

  async getStaffMember(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post("/business-admin/staff/get", { _id: id });
  }

  async createStaffMember(data: any): Promise<AxiosResponse<any>> {
    const dataToSend = {
      ...data,
    };
    const response = await axiosInstance.post(
      "/business-admin/staff/create",
      dataToSend
    );
    return response.data;
  }

  async updateStaffMember(data: any): Promise<AxiosResponse<any>> {
    const dataToSend = {
      ...data,
      _id: data.id,
      id: undefined,
      role_id: data.role,
    };
    return axiosInstance.post("/business-admin/staff/update", dataToSend);
  }

  async deleteStaffMember(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post("/business-admin/staff/delete", { _id: id });
  }
}

export const staffService = new StaffService();
